import { Box, L88 } from "@adfenix/alexandria";
import cx from "classnames";
import { ReactNode } from "react";
import styled from "styled-components";

interface DividerProps {
  vertical?: boolean;
  content?: ReactNode;
  className?: string;
  margin?: string;
  dark?: boolean;
  borderColor?: string;
}

const StyledDivider = styled(Box)<{
  margin: string;
  dark: boolean;
  borderColor?: string;
}>`
  border-color: ${({ theme, dark }) =>
    dark ? "#4B526B" : L88(theme.colors.grey)} !important;
  margin: ${({ margin }) => margin} !important;

  ${({ borderColor }) =>
    borderColor && `border-color: ${borderColor} !important;`}
`;

const Divider = ({
  vertical,
  content,
  className,
  dark = false,
  margin = "16px 0 24px 0",
  borderColor
}: DividerProps) => {
  return (
    <StyledDivider
      borderColor={borderColor}
      dark={dark}
      margin={margin}
      className={cx("is-divider" + (vertical ? "-vertical" : ""), className)}
      data-content={content}
    />
  );
};

export default Divider;
